// ----------------------------------------------------------------------
// V2 Modern Button Styling

import { alpha } from '@mui/material/styles';
import { PRIMARY_MAIN, PRIMARY_LIGHT } from '../palette';

export default function Button(theme) {
  const primaryMain = PRIMARY_MAIN;
  const primaryLight = PRIMARY_LIGHT;

  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          textTransform: 'none', // V2: No uppercase
          fontWeight: 600,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-1px)'
          }
        },
        sizeLarge: {
          height: 48,
          padding: theme.spacing(1.5, 3)
        },
        sizeMedium: {
          minHeight: 44,
          padding: theme.spacing(1, 2.5)
        },
        sizeSmall: {
          minHeight: 36,
          padding: theme.spacing(0.75, 2)
        },
        // V2: Gradient contained primary
        containedPrimary: {
          background: `linear-gradient(135deg, ${primaryMain} 0%, ${primaryLight} 100%)`,
          boxShadow: theme.customShadows.v2?.button || theme.customShadows.primary,
          '&:hover': {
            background: `linear-gradient(135deg, ${alpha(primaryMain, 0.9)} 0%, ${primaryMain} 100%)`,
            boxShadow: theme.customShadows.v2?.hover || theme.customShadows.primary
          }
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.v2?.subtle || theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[300]
          }
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary
        },
        containedInfo: {
          boxShadow: theme.customShadows.info
        },
        containedSuccess: {
          boxShadow: theme.customShadows.v2?.success || theme.customShadows.success
        },
        containedWarning: {
          boxShadow: theme.customShadows.v2?.warning || theme.customShadows.warning
        },
        containedError: {
          boxShadow: theme.customShadows.error
        },
        // V2: Outlined with primary tint
        outlinedPrimary: {
          borderColor: primaryMain,
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.08),
            borderColor: primaryMain
          }
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        // V2: Text with hover tint
        textPrimary: {
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.08)
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  };
}
